import { useState } from "react";

import Input from "../../../components/common/Input";
import Button from "../../../components/common/Button";
import ErrorMessage from "../../../components/common/ErrorMessage";

const ChangePasswordForm = ({
  onSubmit,
  onCancel,
  loading = false,
  serverError = ""
}) => {
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: ""
  });

  const [errors, setErrors] = useState({});

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((previous) => ({
      ...previous,
      [name]: value
    }));

    setErrors((previous) => ({
      ...previous,
      [name]: ""
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.newPassword) {
      newErrors.newPassword =
        "New password is required";
    } else if (
      formData.newPassword.length < 8
    ) {
      newErrors.newPassword =
        "Password must contain at least 8 characters";
    } else if (
      formData.newPassword.length > 72
    ) {
      newErrors.newPassword =
        "Password cannot exceed 72 characters";
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword =
        "Please confirm the password";
    } else if (
      formData.newPassword !==
      formData.confirmPassword
    ) {
      newErrors.confirmPassword =
        "Passwords do not match";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validate()) {
      return;
    }

    try {
      await onSubmit({
        newPassword: formData.newPassword
      });

      setFormData({
        newPassword: "",
        confirmPassword: ""
      });

      setErrors({});
    } catch (error) {
      const details =
        error?.response?.data?.details;

      if (details) {
        setErrors(details);
      }
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-5"
    >
      {serverError && (
        <ErrorMessage message={serverError} />
      )}

      <Input
        label="New password"
        name="newPassword"
        type="password"
        placeholder="Enter new password"
        value={formData.newPassword}
        onChange={handleChange}
        error={errors.newPassword}
        disabled={loading}
        autoComplete="new-password"
      />

      <Input
        label="Confirm password"
        name="confirmPassword"
        type="password"
        placeholder="Confirm new password"
        value={formData.confirmPassword}
        onChange={handleChange}
        error={errors.confirmPassword}
        disabled={loading}
        autoComplete="new-password"
      />

      <p className="text-xs text-slate-500">
        Password must contain between 8 and 72
        characters.
      </p>

      <div className="flex items-center justify-end gap-3 pt-4 border-t border-slate-200">
        <Button
          type="button"
          variant="secondary"
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </Button>

        <Button
          type="submit"
          loading={loading}
          disabled={loading}
        >
          Update password
        </Button>
      </div>
    </form>
  );
};

export default ChangePasswordForm;